import { createStyles, Stack } from '@mantine/core';
import { UserRole } from '@repo/common/enums/UserRole';
import { Banner, Text } from '@repo/foundations';
import { useCheckIAMPermission } from '../../../../../../utils/authorization/roles';

const useStyles = createStyles((theme) => ({
	wrapper: {
		background: theme.other.getColor('surface/secondary/default'),
		borderRadius: theme.radius.md,
		border: `solid ${theme.other.borderWidth.sm}px ${theme.other.getColor('border/critical-secondary/default')}`,
	},
	code: {
		...theme.fn.fontStyles(),
		fontFamily: theme.fontFamilyMonospace,
		fontSize: theme.fontSizes.xs,
	},
}));

export function QueryBlockErrorFallback({ error }: { error: Error }) {
	const { classes } = useStyles();

	const { hasPermission } = useCheckIAMPermission({
		v1AllowedRoles: [
			UserRole.ADMIN,
			UserRole.EDITOR,
			UserRole.VIEWER,
			UserRole.GUEST,
		],
		v2Permission: 'Queries.Read',
	});

	if (!hasPermission) {
		return (
			<Banner
				tone="warning"
				title="Query access required"
				message="You don't have permission to view this query. Contact your workspace administrator to request access to queries."
			/>
		);
	}

	return (
		<Stack className={classes.wrapper} spacing="sm" py="md" px="md">
			<Text size="sm" fw={600}>
				Unhandled error
			</Text>
			<Text
				size="sm"
				color="text/critical/default"
				className={classes.code}
				pl="sm"
			>
				There was an error while loading this query block.
			</Text>
		</Stack>
	);
}
